export const redirectURL = {
  "/account": {
    old: "https://www.gogreendrop.com/account",
    new: "https://scheduling.gogreendrop.com/account",
    utm: true,
  },
  "/account/profile": {
    old: "https://www.gogreendrop.com/account/profile",
    new: "https://scheduling.gogreendrop.com/account",
    utm: true,
  },
  "/pick-up": {
    old: "https://www.gogreendrop.com/pick-up",
    new: "https://scheduling.gogreendrop.com/",
    utm: true,
  },
  "/pickup": {
    old: "https://www.gogreendrop.com/pickup",
    new: "https://scheduling.gogreendrop.com/",
    utm: true,
  },
  "/find-a-location": [
    {
      old: "https://www.gogreendrop.ca/find-a-location",
      new: "https://locations.gogreendrop.com/?lang=en&country=ca",
      utm: true,
    },
    {
      old: "https://www.gogreendrop.com/find-a-location",
      new: "https://locations.gogreendrop.com",
      utm: true,
    },
  ],
  "/fr/trouver-un-sites-de-dons": {
    old: "https://www.gogreendrop.ca/fr/trouver-un-sites-de-dons",
    new: "https://locations.gogreendrop.com/?lang=fr&country=ca",
    utm: true,
  },
  "/find-a-location/88th-avenue-walgreens-anchorage-ak": {
    old: "https://www.gogreendrop.com/find-a-location/88th-avenue-walgreens-anchorage-ak",
    new: "https://locations.gogreendrop.com/ak/anchorage/greendrop-donation-center-4691.html",
    utm: true,
  },
  "/find-a-location/lions-club-sports-park-eagle-river-ak": {
    old: "https://www.gogreendrop.com/find-a-location/lions-club-sports-park-eagle-river-ak",
    new: "https://locations.gogreendrop.com/ak/eagleriver/greendrop-donation-center-4690.html",
    utm: true,
  },

  "/find-a-location/three-bears-sg-chugiak-ak": {
    old: "https://www.gogreendrop.com/find-a-location/three-bears-sg-chugiak-ak",
    new: "https://locations.gogreendrop.com/ak/chugiak/greendrop-donation-center-4692.html",
    utm: true,
  },
  "find-a-location/three-bears-sg-palmer-ak": {
    old: "https://www.gogreendrop.com/find-a-location/three-bears-sg-palmer-ak",
    new: "https://locations.gogreendrop.com/ak/palmer/greendrop-donation-center-4693.html",
    utm: true,
  },
  "/find-a-location/three-bears-sg-wasilla-ak": {
    old: "https://www.gogreendrop.com/find-a-location/three-bears-sg-wasilla-ak",
    new: "https://locations.gogreendrop.com/ak/wasilla/greendrop-donation-center-4694.html",
    utm: true,
  },
  "/find-a-location/wilmington": {
    old: "https://www.gogreendrop.com/find-a-location/wilmington",
    new: "https://locations.gogreendrop.com/de/wilmington/greendrop-donation-center-4628.html",
    utm: true,
  },
  "/find-a-location/friendshipheights": {
    old: "https://www.gogreendrop.com/find-a-location/friendshipheights",
    new: "https://locations.gogreendrop.com/dc/washington/greendrop-donation-center-4611.html",
    utm: true,
  },
  "/find-a-location/ewa-pointe-marketplace-ewa-beach-hi": {
    old: "https://www.gogreendrop.com/find-a-location/ewa-pointe-marketplace-ewa-beach-hi",
    new: "https://locations.gogreendrop.com/hi/ewabeach/greendrop-donation-center-4688.html",
    utm: true,
  },
  "/find-a-location/hawaii-kai-honolulu-hi": {
    old: "https://www.gogreendrop.com/find-a-location/hawaii-kai-honolulu-hi",
    new: "https://locations.gogreendrop.com/hi/honolulu/greendrop-donation-center-4651.html",
    utm: true,
  },
  "/find-a-location/hawaii-kai-towne-center-honolulu-hi": {
    old: "https://www.gogreendrop.com/find-a-location/hawaii-kai-towne-center-honolulu-hi",
    new: "https://locations.gogreendrop.com/hi/honolulu/greendrop-donation-center-4712.html",
    utm: true,
  },
  "/find-a-location/ka-makana-alii-kapolei-hi": {
    old: "https://www.gogreendrop.com/find-a-location/ka-makana-alii-kapolei-hi",
    new: "https://locations.gogreendrop.com/hi/kapolei/greendrop-donation-center-4645.html",
    utm: true,
  },
  "/find-a-location/kailua-hi": {
    old: "https://www.gogreendrop.com/find-a-location/kailua-hi",
    new: "https://locations.gogreendrop.com/hi/kailua/greendrop-donation-center-4653.html",
    utm: true,
  },
  "/find-a-location/kalihi-honolulu-hi": {
    old: "https://www.gogreendrop.com/find-a-location/kalihi-honolulu-hi",
    new: "https://locations.gogreendrop.com/hi/honolulu/greendrop-donation-center-4683.html",
    utm: true,
  },
  "/find-a-location/manoa-marketplace-honolulu-hi": {
    old: "https://www.gogreendrop.com/find-a-location/manoa-marketplace-honolulu-hi",
    new: "https://locations.gogreendrop.com/hi/honolulu/greendrop-donation-center-4714.html",
    utm: true,
  },
  "/find-a-location/mililani-hi": {
    old: "https://www.gogreendrop.com/find-a-location/mililani-hi",
    new: "https://locations.gogreendrop.com/hi/mililani/greendrop-donation-center-4711.html",
    utm: true,
  },
  "find-a-location/kapolei-hi": {
    old: "https://www.gogreendrop.com/find-a-location/kapolei-hi",
    new: "https://locations.gogreendrop.com/hi/kapolei/greendrop-donation-center-4689.html",
    utm: true,
  },
  "/find-a-location/pearlridge-center-aiea-hi": {
    old: "https://www.gogreendrop.com/find-a-location/pearlridge-center-aiea-hi",
    new: "https://locations.gogreendrop.com/hi/aiea/greendrop-donation-center-4713.html",
    utm: true,
  },
  "/find-a-location/stadium-marketplace-honolulu-hi": {
    old: "https://www.gogreendrop.com/find-a-location/stadium-marketplace-honolulu-hi",
    new: "https://locations.gogreendrop.com/hi/honolulu/greendrop-donation-center-4648.html",
    utm: true,
  },
  "/find-a-location/windward-mall-kaneohe-hi": {
    old: "https://www.gogreendrop.com/find-a-location/windward-mall-kaneohe-hi",
    new: "https://locations.gogreendrop.com/hi/kaneohe/greendrop-donation-center-4674.html",
    utm: true,
  },
  "/find-a-location/northbrook-il": {
    old: "https://www.gogreendrop.com/find-a-location/northbrook-il",
    new: "https://locations.gogreendrop.com/il/northbrook/greendrop-donation-center-4678.html",
    utm: true,
  },
  "/find-a-location/arundelmillscir": {
    old: "https://www.gogreendrop.com/find-a-location/arundelmillscir",
    new: "https://locations.gogreendrop.com/md/hanover/greendrop-donation-center-4643.html",
    utm: true,
  },
  "/find-a-location/bel-air-md": {
    old: "https://www.gogreendrop.com/find-a-location/bel-air-md",
    new: "https://locations.gogreendrop.com/md/belair/greendrop-donation-center-4660.html",
    utm: true,
  },
  "/find-a-location/cloppers-mill-germantown-md": {
    old: "https://www.gogreendrop.com/find-a-location/cloppers-mill-germantown-md",
    new: "https://locations.gogreendrop.com/md/germantown/greendrop-donation-center-4646.html",
    utm: true,
  },
  "/find-a-location/essex": {
    old: "https://www.gogreendrop.com/find-a-location/essex",
    new: "https://locations.gogreendrop.com/md/essex/greendrop-donation-center-4638.html",
    utm: true,
  },
  "/find-a-location/laurel-plaza": {
    old: "https://www.gogreendrop.com/find-a-location/laurel-plaza",
    new: "https://locations.gogreendrop.com/md/laurel/greendrop-donation-center-4600.html",
    utm: true,
  },
  "/find-a-location/towson-md": {
    old: "https://www.gogreendrop.com/find-a-location/towson-md",
    new: "https://locations.gogreendrop.com/md/towson/greendrop-donation-center-4617.html",
    utm: true,
  },
  "/find-a-location/whitemarshmd": {
    old: "https://www.gogreendrop.com/find-a-location/whitemarshmd",
    new: "https://locations.gogreendrop.com/md/baltimore/greendrop-donation-center-4610.html",
    utm: true,
  },
  "/find-a-location/york-md": {
    old: "https://www.gogreendrop.com/find-a-location/york-md",
    new: "https://locations.gogreendrop.com/md/baltimore/greendrop-donation-center-4619.html",
    utm: true,
  },
  "/find-a-location/centennial-center-las-vegas-nv": {
    old: "https://www.gogreendrop.com/find-a-location/centennial-center-las-vegas-nv",
    new: "https://locations.gogreendrop.com/nv/lasvegas/greendrop-donation-center-4696.html",
    utm: true,
  },
  "/find-a-location/eastern-beltway-las-vegas-nv": {
    old: "https://www.gogreendrop.com/find-a-location/eastern-beltway-las-vegas-nv",
    new: "https://locations.gogreendrop.com/nv/lasvegas/greendrop-donation-center-4697.html",
    utm: true,
  },
  "/find-a-location/eastern-springs-village-las-vegas-nv": {
    old: "https://www.gogreendrop.com/find-a-location/eastern-springs-village-las-vegas-nv",
    new: "https://locations.gogreendrop.com/nv/lasvegas/greendrop-donation-center-4682.html",
    utm: true,
  },
  "/find-a-location/green-valley-crossing-henderson-nv": {
    old: "https://www.gogreendrop.com/find-a-location/green-valley-crossing-henderson-nv",
    new: "https://locations.gogreendrop.com/nv/henderson/greendrop-donation-center-4684.html",
    utm: true,
  },
  "/find-a-location/lv-premium-outlets-nv": {
    old: "https://www.gogreendrop.com/find-a-location/lv-premium-outlets-nv",
    new: "https://locations.gogreendrop.com/nv/lasvegas/greendrop-donation-center-4681.html",
    utm: true,
  },
  "/find-a-location/shadow-hills-las-vegas-nv": {
    old: "https://www.gogreendrop.com/find-a-location/shadow-hills-las-vegas-nv",
    new: "https://locations.gogreendrop.com/nv/lasvegas/greendrop-donation-center-4675.html",
    utm: true,
  },
  "/find-a-location/shadow-mountain-las-vegas-nv": {
    old: "https://www.gogreendrop.com/find-a-location/shadow-mountain-las-vegas-nv",
    new: "https://locations.gogreendrop.com/nv/lasvegas/greendrop-donation-center-4650.html",
    utm: true,
  },
  "/find-a-location/tropicana-las-vegas-nv": {
    old: "https://www.gogreendrop.com/find-a-location/tropicana-las-vegas-nv",
    new: "https://locations.gogreendrop.com/nv/lasvegas/greendrop-donation-center-4657.html",
    utm: true,
  },
  "/find-a-location/metuchen": {
    old: "https://www.gogreendrop.com/find-a-location/metuchen",
    new: "https://locations.gogreendrop.com/nj/metuchen/greendrop-donation-center-4631.html",
    utm: true,
  },
  "/find-a-location/newport-plaza-jersey-city-nj": {
    old: "https://www.gogreendrop.com/find-a-location/newport-plaza-jersey-city-nj",
    new: "https://locations.gogreendrop.com/nj/jerseycity/greendrop-donation-center-4654.html",
    utm: true,
  },
  "/find-a-location/springfield": {
    old: "https://www.gogreendrop.com/find-a-location/springfield",
    new: "https://locations.gogreendrop.com/nj/springfield/greendrop-donation-center-4632.html",
    utm: true,
  },
  "/find-a-location/totowanj": {
    old: "https://www.gogreendrop.com/find-a-location/totowanj",
    new: "https://locations.gogreendrop.com/nj/totowa/greendrop-donation-center-4635.html",
    utm: true,
  },
  "/find-a-location/cheektowaga-ny": {
    old: "https://www.gogreendrop.com/find-a-location/cheektowaga-ny",
    new: "https://locations.gogreendrop.com/ny/cheektowaga/greendrop-donation-center-4715.html",
    utm: true,
  },
  "/find-a-location/depew-ny": {
    old: "https://www.gogreendrop.com/find-a-location/depew-ny",
    new: "https://locations.gogreendrop.com/ny/depew/greendrop-donation-center-4685.html",
    utm: true,
  },
  "/find-a-location/orchard-park-ny": {
    old: "https://www.gogreendrop.com/find-a-location/orchard-park-ny",
    new: "https://locations.gogreendrop.com/ny/orchardpark/greendrop-donation-center-4677.html",
    utm: true,
  },
  "/find-a-location/lake-grove-ny": {
    old: "https://www.gogreendrop.com/find-a-location/lake-grove-ny",
    new: "https://locations.gogreendrop.com/ny/lakegrove/greendrop-donation-center-4644.html",
    utm: true,
  },
  "/find-a-location/huntington-station-ny": {
    old: "https://www.gogreendrop.com/find-a-location/huntington-station-ny",
    new: "https://locations.gogreendrop.com/ny/huntingtonstation/greendrop-donation-center-4642.html",
    utm: true,
  },
  "/find-a-location/white-plains": {
    old: "https://www.gogreendrop.com/find-a-location/white-plains",
    new: "https://locations.gogreendrop.com/ny/whiteplains/greendrop-donation-center-4636.html",
    utm: true,
  },
  "/find-a-location/aston": {
    old: "https://www.gogreendrop.com/find-a-location/aston",
    new: "https://locations.gogreendrop.com/pa/aston/greendrop-donation-center-4621.html",
    utm: true,
  },
  "/find-a-location/bensalem-pa": {
    old: "https://www.gogreendrop.com/find-a-location/bensalem-pa",
    new: "https://locations.gogreendrop.com/pa/bensalem/greendrop-donation-center-4656.html",
    utm: true,
  },
  "/find-a-location/brookhaven-pa": {
    old: "https://www.gogreendrop.com/find-a-location/brookhaven-pa",
    new: "https://locations.gogreendrop.com/pa/brookhaven/greendrop-donation-center-4672.html",
    utm: true,
  },
  "/find-a-location/broomall": {
    old: "https://www.gogreendrop.com/find-a-location/broomall",
    new: "https://locations.gogreendrop.com/pa/broomall/greendrop-donation-center-4602.html",
    utm: true,
  },
  "/find-a-location/doylestown": {
    old: "https://www.gogreendrop.com/find-a-location/doylestown",
    new: "https://locations.gogreendrop.com/pa/doylestown/greendrop-donation-center-4604.html",
    utm: true,
  },
  "/find-a-location/exton": {
    old: "https://www.gogreendrop.com/find-a-location/exton",
    new: "https://locations.gogreendrop.com/pa/exton/greendrop-donation-center-4603.html",
    utm: true,
  },
  "/find-a-location/frazer-malvern": {
    old: "https://www.gogreendrop.com/find-a-location/frazer-malvern",
    new: "https://locations.gogreendrop.com/pa/malvern/greendrop-donation-center-4622.html",
    utm: true,
  },
  "/find-a-location/king-of-prussia-pa": {
    old: "https://www.gogreendrop.com/find-a-location/king-of-prussia-pa",
    new: "https://locations.gogreendrop.com/pa/kingofprussia/greendrop-donation-center-4658.html",
    utm: true,
  },
  "/find-a-location/media": {
    old: "https://www.gogreendrop.com/find-a-location/media",
    new: "https://locations.gogreendrop.com/pa/media/greendrop-donation-center-4623.html",
    utm: true,
  },
  "/find-a-location/narberth": {
    old: "https://www.gogreendrop.com/find-a-location/narberth",
    new: "https://locations.gogreendrop.com/pa/narberth/greendrop-donation-center-4624.html",
    utm: true,
  },
  "/find-a-location/newtown": {
    old: "https://www.gogreendrop.com/find-a-location/newtown",
    new: "https://locations.gogreendrop.com/pa/newtownsquare/greendrop-donation-center-4634.html",
    utm: true,
  },
  "/find-a-location/paoli": {
    old: "https://www.gogreendrop.com/find-a-location/paoli",
    new: "https://locations.gogreendrop.com/pa/paoli/greendrop-donation-center-4633.html",
    utm: true,
  },
  "/find-a-location/philadelphia-premium-outlets-pottstown-pa": {
    old: "https://www.gogreendrop.com/find-a-location/philadelphia-premium-outlets-pottstown-pa",
    new: "https://locations.gogreendrop.com/pa/pottstown/greendrop-donation-center-4661.html",
    utm: true,
  },
  "/find-a-location/phoenixville": {
    old: "https://www.gogreendrop.com/find-a-location/phoenixville",
    new: "https://locations.gogreendrop.com/pa/phoenixville/greendrop-donation-center-4601.html",
    utm: true,
  },
  "/find-a-location/plymouth": {
    old: "https://www.gogreendrop.com/find-a-location/plymouth",
    new: "https://locations.gogreendrop.com/pa/conshohocken/greendrop-donation-center-4605.html",
    utm: true,
  },
  "/find-a-location/west-chester": {
    old: "https://www.gogreendrop.com/find-a-location/west-chester",
    new: "https://locations.gogreendrop.com/pa/westchester/greendrop-donation-center-4625.html",
    utm: true,
  },
  "/find-a-location/west-norriton": {
    old: "https://www.gogreendrop.com/find-a-location/west-norriton",
    new: "https://locations.gogreendrop.com/pa/norristown/greendrop-donation-center-4629.html",
    utm: true,
  },
  "/find-a-location/willow-grove": {
    old: "https://www.gogreendrop.com/find-a-location/willow-grove",
    new: "https://locations.gogreendrop.com/pa/willowgrove/greendrop-donation-center-4630.html",
    utm: true,
  },
  "/find-a-location/alexandria": {
    old: "https://www.gogreendrop.com/find-a-location/alexandria",
    new: "https://locations.gogreendrop.com/va/alexandria/greendrop-donation-center-4627.html",
    utm: true,
  },
  "/find-a-location/braemar-bristow-va": {
    old: "https://www.gogreendrop.com/find-a-location/braemar-bristow-va",
    new: "https://locations.gogreendrop.com/va/bristow/greendrop-donation-center-4614.html",
    utm: true,
  },
  "/find-a-location/centreville": {
    old: "https://www.gogreendrop.com/find-a-location/centreville",
    new: "https://locations.gogreendrop.com/va/centreville/greendrop-donation-center-4606.html",
    utm: true,
  },
  "/find-a-location/gsvfd": {
    old: "https://www.gogreendrop.com/find-a-location/gsvfd",
    new: "https://locations.gogreendrop.com/va/springfield/greendrop-donation-center-4609.html",
    utm: true,
  },
  "/find-a-location/greenbriar": {
    old: "https://www.gogreendrop.com/find-a-location/greenbriar",
    new: "https://locations.gogreendrop.com/va/fairfax/greendrop-donation-center-4608.html",
    utm: true,
  },
  "/find-a-location/herndon-va": {
    old: "https://www.gogreendrop.com/find-a-location/herndon-va",
    new: "https://locations.gogreendrop.com/va/herndon/greendrop-donation-center-4613.html",
    utm: true,
  },
  "/find-a-location/kings-park-springfield-va": {
    old: "https://www.gogreendrop.com/find-a-location/kings-park-springfield-va",
    new: "https://locations.gogreendrop.com/va/springfield/greendrop-donation-center-4655.html",
    utm: true,
  },
  "/find-a-location/lorton": {
    old: "https://www.gogreendrop.com/find-a-location/lorton",
    new: "https://locations.gogreendrop.com/va/lorton/greendrop-donation-center-4616.html",
    utm: true,
  },
  "/find-a-location/manchester-lakes-franconia-va": {
    old: "https://www.gogreendrop.com/find-a-location/manchester-lakes-franconia-va",
    new: "https://locations.gogreendrop.com/va/franconia/greendrop-donation-center-4647.html",
    utm: true,
  },
  "/find-a-location/saratoga": {
    old: "https://www.gogreendrop.com/find-a-location/saratoga",
    new: "https://locations.gogreendrop.com/va/springfield/greendrop-donation-center-4607.html",
    utm: true,
  },
  "/find-a-location/shops-at-county-center-manassas-va": {
    old: "https://www.gogreendrop.com/find-a-location/shops-at-county-center-manassas-va",
    new: "https://locations.gogreendrop.com/va/manassas/greendrop-donation-center-4649.html",
    utm: true,
  },
  "/find-a-location/stoneridge": {
    old: "https://www.gogreendrop.com/find-a-location/stoneridge",
    new: "https://locations.gogreendrop.com/va/aldie/greendrop-donation-center-4615.html",
    utm: true,
  },
  "/find-a-location/universitymall-va": {
    old: "https://www.gogreendrop.com/find-a-location/universitymall-va",
    new: "https://locations.gogreendrop.com/va/fairfax/greendrop-donation-center-4612.html",
    utm: true,
  },
  "/find-a-location/woodbridge": {
    old: "https://www.gogreendrop.com/find-a-location/woodbridge",
    new: "https://locations.gogreendrop.com/va/woodbridge/greendrop-donation-center-4640.html",
    utm: true,
  },
  "/careers": [
    {
      old: "https://www.gogreendrop.com/careers",
      new: "https://careers.savers.com/search/jobs?location=&q=GreenDrop",
      utm: true,
    },
    {
      old: "https://gogreendrop.ca/careers",
      new: "https://careers.valuevillage.ca/search/jobs?location=&q=GreenDrop",
      utm: true,
    },
  ],
  "/what-we-do": {
    old: "https://www.gogreendrop.com/what-we-do",
    new: "https://www.gogreendrop.com/about-us",
  },
  "/how-it-works": {
    old: "https://www.gogreendrop.com/how-it-works",
    new: "https://www.gogreendrop.com/about-us",
  },
  "/nonprofit-and-charity-partners": {
    old: "https://www.gogreendrop.com/nonprofit-and-charity-partners",
    new: "https://www.gogreendrop.com/partners",
  },
  "/about-donations": {
    old: "https://www.gogreendrop.com/about-donations",
    new: "https://www.gogreendrop.com/about-us",
  },
  "/faqs": {
    old: "https://www.gogreendrop.com/faqs",
    new: "https://www.gogreendrop.com/contact-us",
  },
  "/ServiceArea": {
    old: "https://www.gogreendrop.com/ServiceArea",
    new: "https://locations.gogreendrop.com",
    utm: true,
  },
  "/acceptable-items": {
    old: "https://www.gogreendrop.com/acceptable-items",
    new: "https://www.gogreendrop.com/what-we-take",
  },

  // vvatlanta Specific page redirects
  "/about-us.html": {
    old: "https://www.valuevillageatlanta.com/about-us.html",
    new: "https://www.valuevillage.com/about-us",
    utm: true,
  },
  "/events.html": {
    old: "https://www.valuevillageatlanta.com/events.html",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/employment.html": {
    old: "https://www.valuevillageatlanta.com/employment.html",
    new: "https://careers.savers.com",
    utm: true,
  },
  "/contact.html": {
    old: "https://www.valuevillageatlanta.com/contact.html",
    new: "https://www.valuevillage.com/contact-us",
    utm: true,
  },
  "/locations-new.html": {
    old: "https://www.valuevillageatlanta.com/locations-new.html",
    new: "https://stores.savers.com/?site=ValueVillage&lang=EN&country=US",
    utm: true,
  },
  "/terms-of-use.html": {
    old: "https://www.valuevillageatlanta.com/terms-of-use.html",
    new: "https://www.valuevillage.com/terms-of-use",
    utm: true,
  },
  "/privacy-policy.html": {
    old: "https://www.valuevillageatlanta.com/privacy-policy.html",
    new: "https://www.valuevillage.com/privacy-policy",
    utm: true,
  },
  "/disclosures.html": {
    old: "https://www.valuevillageatlanta.com/disclosures.html",
    new: "https://www.valuevillage.com/disclosures",
    utm: true,
  },
  "/big-box-vacancies.html": {
    old: "https://www.valuevillageatlanta.com/big-box-vacancies.html",
    new: "https://www.valuevillage.com/real-estate",
    utm: true,
  },
  "/clothing.html": {
    old: "https://www.valuevillageatlanta.com/clothing.html",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/fall-clothing.html": {
    old: "https://www.valuevillageatlanta.com/fall-clothing.html",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/giftcards": [
    {
      old: "https://www.valuevillage.com/giftcards",
      new: "https://www.valuevillage.com/gift-cards",
      utm: true,
    },
    {
      old: "https://www.valuevillage.ca/giftcards",
      new: "https://www.valuevillage.com/gift-cards",
      utm: true,
    },
    {
      old: "https://www.2ndavestores.com/giftcards",
      new: "https://www.2ndavestores.com/gift-cards",
      utm: true,
    },
    {
      old: "https://www.savers.com.au/giftcards",
      new: "https://www.savers.com.au/gift-cards",
      utm: true,
    },
  ],
  "/cartescadeaux": {
    old: "https://www.villagedesvaleurs.ca/cartescadeaux",
    new: "https://www.villagedesvaleurs.ca/cartes-cadeaux",
    utm: true,
  },

  // vvatlanda Wildcard redirects (these would redirect all paths under these directories)
  "/green/*": {
    old: "https://www.valuevillageatlanta.com/green/*",
    new: "https://www.valuevillage.com/donate",
    utm: true,
  },
  "/second-hand/*": {
    old: "https://www.valuevillageatlanta.com/second-hand/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/discount/*": {
    old: "https://www.valuevillageatlanta.com/discount/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/bargain/*": {
    old: "https://www.valuevillageatlanta.com/bargain/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/vintage/*": {
    old: "https://www.valuevillageatlanta.com/vintage/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/thrift/*": {
    old: "https://www.valuevillageatlanta.com/thrift/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/womens/*": {
    old: "https://www.valuevillageatlanta.com/womens/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/mens/*": {
    old: "https://www.valuevillageatlanta.com/mens/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/kids/*": {
    old: "https://www.valuevillageatlanta.com/kids/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/inexpensive/*": {
    old: "https://www.valuevillageatlanta.com/inexpensive/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/used/*": {
    old: "https://www.valuevillageatlanta.com/used/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/junior/*": {
    old: "https://www.valuevillageatlanta.com/junior/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/tween/*": {
    old: "https://www.valuevillageatlanta.com/tween/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/buy/*": {
    old: "https://www.valuevillageatlanta.com/buy/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/antiques/*": {
    old: "https://www.valuevillageatlanta.com/antiques/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/clothing/*": {
    old: "https://www.valuevillageatlanta.com/clothing/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/housewares/*": {
    old: "https://www.valuevillageatlanta.com/housewares/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/new/*": {
    old: "https://www.valuevillageatlanta.com/new/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/jewelry/*": {
    old: "https://www.valuevillageatlanta.com/jewelry/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/bedding/*": {
    old: "https://www.valuevillageatlanta.com/bedding/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/home/*": {
    old: "https://www.valuevillageatlanta.com/home/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/cookware/*": {
    old: "https://www.valuevillageatlanta.com/cookware/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/small/*": {
    old: "https://www.valuevillageatlanta.com/small/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/costume/*": {
    old: "https://www.valuevillageatlanta.com/costume/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/treasures/*": {
    old: "https://www.valuevillageatlanta.com/treasures/*",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/green": {
    old: "https://www.valuevillageatlanta.com/green",
    new: "https://www.valuevillage.com/donate",
    utm: true,
  },
  "/second-hand": {
    old: "https://www.valuevillageatlanta.com/second-hand",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/discount": {
    old: "https://www.valuevillageatlanta.com/discount",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/bargain": {
    old: "https://www.valuevillageatlanta.com/bargain",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/vintage": {
    old: "https://www.valuevillageatlanta.com/vintage",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/thrift": {
    old: "https://www.valuevillageatlanta.com/thrift",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/womens": {
    old: "https://www.valuevillageatlanta.com/womens",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/mens": {
    old: "https://www.valuevillageatlanta.com/mens",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/kids": {
    old: "https://www.valuevillageatlanta.com/kids",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/inexpensive": {
    old: "https://www.valuevillageatlanta.com/inexpensive",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/used": {
    old: "https://www.valuevillageatlanta.com/used",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/junior": {
    old: "https://www.valuevillageatlanta.com/junior",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/tween": {
    old: "https://www.valuevillageatlanta.com/tween",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/buy": {
    old: "https://www.valuevillageatlanta.com/buy",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/antiques": {
    old: "https://www.valuevillageatlanta.com/antiques",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/clothing": {
    old: "https://www.valuevillageatlanta.com/clothing",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/housewares": {
    old: "https://www.valuevillageatlanta.com/housewares",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/new": {
    old: "https://www.valuevillageatlanta.com/new",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/jewelry": {
    old: "https://www.valuevillageatlanta.com/jewelry",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/bedding": {
    old: "https://www.valuevillageatlanta.com/bedding",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/home": {
    old: "https://www.valuevillageatlanta.com/home",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/cookware": {
    old: "https://www.valuevillageatlanta.com/cookware",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/small": {
    old: "https://www.valuevillageatlanta.com/small",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/costume": {
    old: "https://www.valuevillageatlanta.com/costume",
    new: "https://www.valuevillage.com",
    utm: true,
  },
  "/treasures": {
    old: "https://www.valuevillageatlanta.com/treasures",
    new: "https://www.valuevillage.com",
    utm: true,
  },
};
